var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.214 3.042c1.983 0 3.594 1.634 3.594 3.645 0 2.012-1.611 3.646-3.594 3.646-1.983 0-3.594-1.634-3.594-3.646 0-2.011 1.611-3.645 3.594-3.645zm4.107 10.416c1.697 0 3.08 1.403 3.08 3.125 0 0-.057 1.848-.759 2.56-.821.832-3.783 2.052-6.428 2.023-2.842-.031-5.89-1.898-6.785-3.095-.206-.275-.402-1.488-.402-1.488 0-1.722 1.383-3.125 3.08-3.125 2.727 0 2.16.52 4.107.52 1.954 0 1.377-.52 4.107-.52zM12.214 2c-2.55 0-4.62 2.1-4.62 4.687 0 2.588 2.07 4.688 4.62 4.688 2.55 0 4.62-2.1 4.62-4.688C16.834 4.1 14.764 2 12.214 2zm4.107 10.416c-2.965 0-2.278.521-4.107.521-1.822 0-1.146-.52-4.107-.52C5.839 12.416 4 14.28 4 16.582v.416c0 .323.1.936.357 1.429.203.389.67.714 1.072 1.071 0 0 2.678 2.455 6.785 2.5 3.987.044 6.428-1.785 6.428-1.785.385-.196 1.072-.715 1.429-1.429.357-.714.357-1.428.357-1.428v-.774c0-2.302-1.839-4.167-4.107-4.167z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c647209fcde5975d845532cf3c69558a.svg";
export { ForwardRef as ReactComponent };